module.exports = __webpack_public_path__ + "img/E-WEB-Goal-17.3b99bc1d.svg";